<template>
	<nk-page commercialAccess="Warehouse" :policyClaims="{ or: ['Warehouse_ProductWarehouse_Edit', 'Warehouse_ProductWarehouse_Add'] }">
		<template #badges>
			<nk-badge system="sale">
				<nk-badge-item type="system" modelValue="sale"></nk-badge-item>
				<nk-badge-item type="system" modelValue="sale" :title="$t(`forms.Warehouse`)"></nk-badge-item>
				<nk-badge-item type="edition" :modelValue="retreiveIsEmpty() ? 'new' : 'edit'"></nk-badge-item>
			</nk-badge>
		</template>
		<div class="container-fluid warehouse-modify form-container">
			<div class="nk-card d-flex flex-column h-100">
				<div class="row" style="margin-bottom: 20px">
					<div class="col-12 col-sm-6">
						<nk-col-form-group :label="$t('sale.warehouse.f.code') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
							<nk-input v-model="localData.code" :options="componentOptions.codeInput" :disabled="true" :tabindex="101">
							</nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6">
						<nk-col-form-group :label="$t('sale.warehouse.f.name') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
							<nk-input v-model="localData.name" :options="componentOptions.nameInput" :tabindex="102" ref="name">
							</nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-12 col-sm-6">
						<nk-col-form-group :label="$t('sale.warehouse.f.type') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 9 }">
							<nk-dropdown v-model="warehouseType" :data="warehouseTypes" :options="componentOptions.typeDropdown" :tabindex="103"></nk-dropdown>
						</nk-col-form-group>
					</div>
				</div>
				<nk-stabs :activeTab="'relate-account'" class="flex-grow-1">
					<nk-stab :id="'relate-account'" :name="$t('sale.warehouse.relate-account')">
						<div class="row no-gutters">
							<div class="col-12 col-sm-6 p-0">
								<nk-col-form-group :label="$t('sale.receipt-hawala.f.account') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
									<nk-dropdown-account v-model="localData.productStockAccount" :options="componentOptions.account" :tabindex="107"></nk-dropdown-account>
								</nk-col-form-group>
							</div>
							<div class="col-12 col-sm-6 p-0" v-for="index in maxCentersLevel" :key="index">
								<nk-col-form-group :label="`${$t('sale.receipt-hawala.f.center')}${maxCentersLevel > 1 ? index.toString().toLocaleDigits() : ''}:`" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
									<nk-dropdown-center v-model="localData.floatingCenters[index - 1]" @update:modelValue="localData.floatingCenters = localData.floatingCenters.filter(x => !!x)" :options="getCenterOptions(index)" :tabindex="108 + index"></nk-dropdown-center>
								</nk-col-form-group>
							</div>
						</div>
					</nk-stab>
					<nk-stab :id="'relatable-products-group'" :name="$t('sale.warehouse.relatable-products-group')">
						<nk-table v-model="selectedRow" :data="relatableProductsGroup" :options="componentOptions.relatableProductsGroup" ref="relatableProductsGroupTable" tabindex="104">
						</nk-table>
					</nk-stab>
					<nk-stab :id="'relatable-products'" :name="$t('sale.warehouse.relatable-products')">
						<nk-table v-model="selectedRow" :data="relatableProducts" :options="componentOptions.relatableProducts" ref="relatableProductsTable" tabindex="105">
						</nk-table>
					</nk-stab>
					<nk-stab :id="'users-permissions'" :name="$t('sale.warehouse.users-permissions')">
						<nk-table v-model="selectedRow" :data="usersPermissions" :options="componentOptions.usersPermissions" ref="usersPermissionsTable" tabindex="106"></nk-table>
					</nk-stab>
				</nk-stabs>
			</div>
		</div>

	</nk-page>
</template>

<script>
	import Input from '~/components/general/nikan-input.vue'
	import { isEmpty } from '../../../statics/validators'
	import $sc from '~/plugins/shortcut.collection.js'
	import validators, { Checker } from '~/statics/validators'
	import Dropdown from '~/components/general/dropdown.vue'
	import ProductGroupDropdown from '~/components/form/dropdown/dropdown-product-group'
	import { post } from '~/plugins/nikan-api'
	import emptyId from '~/statics/empty-id'
	import Endpoints from '@nikan/endpoints'
	import { mapActions, mapGetters } from 'vuex'
	import DropdownProduct from '~/components/form/dropdown/dropdown-product-server'
	import _ from 'lodash'

	export default {
		modal: {
			size: 'md',
			stateUID: 'warehouse-modify',
			helpTag: 'WarehouseModify'
		},
		props: {
			data: { type: [Array, Object] },
			options: { type: Object },
		},
		data() {
			return {
				usersList: [],
				maxCentersLevel: 0,
				localData: {
					id: emptyId,
					productStockAccount: null,
					floatingCenters: []
				},
				userOperations: [],
				selectedRow: null,
				warehouseTypes: null,
				relatableProductsGroup: null,
				relatableProducts: null,
				usersPermissions: null,
				warehouseType: null,
				saveButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: true,
					icon: 'save',
					handle: (button, page, e) => {
						e.preventDefault()
						this.prepareWarehouseDataForSave()
					},
					policyClaims: { or: ['Warehouse_ProductWarehouse_Edit', 'Warehouse_ProductWarehouse_Add'] },
				},
				componentOptions: {
					account: {},
					codeInput: {
						mode: 'string'
					},
					nameInput: {
						mode: 'string'
					},
					typeDropdown: {
						display: (item) => this.$t(`sale.warehouse.types.${item.name.toLowerCase()}`),
						searchPrefix: 'sale.warehouse.types'
					},
					relatableProductsGroup: {
						activeRowDisabled: true,
						editable: true,
						searchable: false,
						buttons: {
							addBtn: {
								options: {
									visible: true,
								}
							},
							deleteBtn: {
								options: {
									visible: true,
								}
							}
						},
						allowNewRow: true,
						prepareNewRow: () => {
							return {
								productGroup: '',
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								searchable: true,
								sortable: true,
								editable: false,
								entering: false,
								pinned: true,
								pinnable: false,
								resizable: false,
								width: '10%',
							},
							{
								name: 'productGroup',
								title: this.$t('sale.product.f.productGroup'),
								edit: {
									component: ProductGroupDropdown,
									options: {
										hideParents: true,
									},
								},
								view: {
									options: {
										format: (item) => item.name
									}
								},
								align: 'right',
								searchable: true,
								sortable: false,
								editable: true,
								validators: validators('required'),
								width: 'auto',
							},
							// {
							// 	name: 'null',
							// 	edit: {
							// 		component: Input,
							// 		options: {
							// 			mode: 'string',
							// 		},
							// 	},
							// 	align: 'center',
							// 	searchable: true,
							// 	sortable: false,
							// 	editable: true,
							// 	width: '45%',
							// },
						],
					},
					relatableProducts: {
						activeRowDisabled: true,
						editable: true,
						searchable: false,
						buttons: {
							addBtn: {
								options: {
									visible: true,
								}
							},
							deleteBtn: {
								options: {
									visible: true,
								}
							}
						},
						allowNewRow: true,
						prepareNewRow: () => {
							return {
								code: '',
								name: '',
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								searchable: true,
								sortable: true,
								editable: false,
								entering: false,
								pinned: true,
								pinnable: false,
								resizable: false,
								width: '10%',
							},
							{
								name: 'product',
								title: this.$t('sale.product.f.name'),
								view: {
									options: {
										format: (item) => `${item && item.name ? item.name : ''} (${item && item.code ? item.code : ''})`,
									},
								},
								edit: (row, col) => {
									return {
										component: DropdownProduct,
										options: {
											onChangeHandler: () => {
												if (row.product) {
													row.productbarcode = {
														product: row.product,
														code:
															row.product.barcodes && row.product.barcodes[0]
																? row.product.barcodes[0].code
																: '',
													}
												} else {
													row.productbarcode = null
												}
											},
											url: Endpoints.getUrl(
												'sale.product.get-integrated-list-for-factor'
											),
											searchFields: ['SearchValue'],
											displayFields: ['code', 'name'],
										},
									}
								},

								align: 'right',
								searchable: true,
								sortable: false,
								editable: true,
								validators: validators('required'),
								width: 'auto',
							},
						],
					},
					usersPermissions: {
						activeRowDisabled: true,
						editable: true,
						searchable: false,
						buttons: {
							addBtn: {
								options: {
									visible: true,
								}
							},
							deleteBtn: {
								options: {
									visible: true,
								}
							}
						},
						allowNewRow: true,
						prepareNewRow: () => {
							return {
								code: '',
								name: '',
							}
						},
						columns: [
							{
								name: 'rowNumber',
								title: this.$t('row-number'),
								searchable: true,
								sortable: true,
								editable: false,
								entering: false,
								pinned: true,
								pinnable: false,
								resizable: false,
								width: '10%',
							},
							{
								name: 'user',
								title: this.$t('document.f.user'),
								edit: () => {
									return {
										component: Dropdown,
										options: {
											rowIdentifier: 'id',
											searchableFields: ['firstName', 'lastName'],
											display: (item) => item.firstName + ' ' + item.lastName,
											getDataFromOptions: true,
											data: this.usersList
										},
									}
								},
								view: {
									options: {
										format: (item) => item.firstName + ' ' + item.lastName,
									},
								},
								align: 'center',
								searchable: true,
								sortable: false,
								editable: true,
								validators: validators('required'),
								width: '45%',
							},
							{
								name: 'operation',
								title: this.$t('sale.warehouse.f.operation'),
								edit: () => {
									return {
										component: Dropdown,
										options: {
											rowIdentifier: 'id',
											display: (item) => this.$t(`sale.warehouse.operations.${item.name}`),
											searchPrefix: 'sale.warehouse.operations',
											getDataFromOptions: true,
											data: this.userOperations
										}
									}
								},
								view: {
									options: {
										format: (item) => this.$t(`sale.warehouse.operations.${item.name}`)
									},
								},
								align: 'center',
								searchable: true,
								sortable: false,
								editable: true,
								validators: validators('required'),
								width: '45%',
							},
						],
					},
				},
				validators: {
					localData: {
						name: validators('required'),
						type: validators('required')
					},
				},
			}
		},
		computed: {
			...mapGetters({
				getPropertiesByGroup: 'properties/getByGroup',
			}),
		},
		mounted() {
			let title = this.data !== null ? this.$t('sale.warehouse.edit-warehouse') : this.$t('sale.warehouse.add-warehouse')
			this.prepareWindow(this.$t(title), [this.saveButton])
			this.getUsersList()
			this.userOperations = this.getPropertiesByGroup('WarehouseOperationTypes')
			this.warehouseTypes = this.getPropertiesByGroup('WarehouseTypes')
			if (this.data) {
				this.prepareWarehouseDataForLoad()
			}
			this.defer(() => this.$refs.name.$el.focus(), 500)

			this.getMaxCentersLevel().then(x => {
				this.maxCentersLevel = x
			})
		},
		methods: {
			...mapActions({
				broadcastRefresh: 'socket/broadcastRefresh',
				getMaxCentersLevel: 'floatingCenters/getMaxCentersLevel',
			}),
			retreiveIsEmpty() {
				return isEmpty(this.localData.id)
			},
			validateInputs() {
				let checker = new Checker((name) => this.$t(`sale.warehouse.f.${name}`))
				let errors = checker.test(this.localData, this.validators.localData)

				this.validationToast(errors)
				return errors.length === 0
			},
			getUsersList() {
				post(Endpoints.getUrl('user.list'))
					.then((result) => {
						this.usersList = result.data.items
					}).catch(() => { })
			},

			async save() {
				let url

				if (isEmpty(this.localData.id)) {
					url = Endpoints.getUrl('sale.warehouse.create')
				} else {
					url = Endpoints.getUrl('sale.warehouse.update')
				}

				let data = {
					warehouse: this.localData
				}

				if (this.validateInputs()) {
					let wait = this.$wait(this.grandParent)

					post(url, data).then((res) => {
						wait.end()
						this.$toast(this.$t('sale.warehouse.m.save.success', { code: res.data.code }), { type: 'success' })
						this.broadcastRefresh('Warehouses')
						this.resolve()
					}).catch(() => {
						wait.end()
					})
				}

			},
			prepareWarehouseDataForLoad() {
				this.localData = _.cloneDeep(this.data)

				for (let i = 0; i < this.warehouseTypes.length; i++) {
					if (this.warehouseTypes[i].key == this.data.type) {
						this.warehouseType = this.warehouseTypes[i]
						break
					}
				}


				let usersTableData = []
				this.data.permitUserWarehouses.forEach((item) => {
					let obj = {
						id: item.id,
						user: item.user,
						rowState: 'unchanged',
					}
					for (let i = 0; i < this.userOperations.length; i++) {
						if (this.userOperations[i].key == item.operation) {
							obj.operation = this.userOperations[i]
							break
						}
					}
					usersTableData.push(obj)
				})
				this.usersPermissions = usersTableData



				let productTableData = []
				let productGroupTableData = []

				this.data.assignableProductWarehouses.forEach((item) => {
					let obj = {
						id: item.id,
						rowState: 'unchanged',
					}
					if (item.product) {
						obj.product = item.product
						productTableData.push(obj)
					}
					else if (item.productGroup) {
						obj.productGroup = item.productGroup
						productGroupTableData.push(obj)
					}
				})


				this.relatableProducts = productTableData
				this.relatableProductsGroup = productGroupTableData

			},
			async prepareWarehouseDataForSave() {
				let relatableProductGroups = await this.$refs.relatableProductsGroupTable.commitChanges()
				let relatableProduct = await this.$refs.relatableProductsTable.commitChanges()
				let usersPermissions = await this.$refs.usersPermissionsTable.commitChanges()

				let permitUserWarehouses = []
				usersPermissions.forEach((item) => {
					permitUserWarehouses.push({
						warehouseId: this.localData.id,
						user: item.user,
						operation: item.operation.key,
						rowState: item.rowState,
						id: item.id,
					})
				})

				let assignableProductWarehouses = []

				relatableProductGroups.forEach((item) => {
					assignableProductWarehouses.push({
						warehouseId: this.localData.id,
						productGroup: item.productGroup,
						rowState: item.rowState,
						id: item.id,
					})
				})

				relatableProduct.forEach((item) => {
					assignableProductWarehouses.push({
						warehouseId: this.localData.id,
						product: item.product,
						rowState: item.rowState,
						id: item.id,
					})
				})

				this.localData.floatingCenters = this.localData.floatingCenters.map((x, index) => {
					x.level = (index + 1)
					return x
				})

				this.localData.permitUserWarehouses = permitUserWarehouses
				this.localData.assignableProductWarehouses = assignableProductWarehouses

				this.localData.type = (this.warehouseType || {}).key
				this.save()
			},
			getCenterOptions(index) {
				return {
					rowIdentifier: 'id',
					searchable: true,
					required: true,
					baseAccountId: this.localData.productStockAccount ? this.localData.productStockAccount.id : null,
					centerLevel: index,
					remoteSearch: false,
					placeholder: this.$t('autoAccount.choose-center'),
					display: (item) => `${item.accountingCode} - ${item.name}`,
					searchableFields: ['name', 'accountingCode'],
					selectorWidth: 350,
					loadAllIfBaseAccountIsEmpty: false,
					linkNewCenterToAccount: true,
					includeAccounts: true
				}
			}
		},

	}
</script>

<style>
	.warehouse-modify {
		height: 100%;
	}

	@media screen and (max-width: 768px) {
		.warehouse-modify {
			height: auto;
		}
	}
</style>